import styled, { css } from 'styled-components'
import { tabletBreakpoint, desktopBreakpoint, wideScreenBreakpoint } from 'react-components'

export const Section = styled.section(
    ({ theme }) => css`
        width: inherit;
        padding: ${theme.spacing.medium} 0 ${theme.spacing.xSmall};

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            padding: ${theme.spacing.xSmall} ${theme.spacing.large} ${theme.spacing.medium};
        }

        @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
            padding: ${theme.spacing.xLarge} 4rem ${theme.spacing.medium};
        }
    `,
)

export const TitleContainer = styled.div(
    ({ theme }) => css`
        padding: ${theme.spacing.small} ${theme.spacing.medium} ${theme.spacing.xxSmall};

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            padding: ${theme.spacing.small} ${theme.spacing.large} ${theme.spacing.xxSmall};
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            padding: ${theme.spacing.xSmall} 0 ${theme.spacing.xSmall};
        }
    `,
)

export const Title = styled.h2(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: 1.25rem;
        font-weight: ${theme.typography.font.weight.bold};
        line-height: 1.625rem;
        color: #282828;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            font-size: ${theme.typography.font.size.xxLarge};
            line-height: 2.5rem;
        }
    `,
)

export const CtaContainer = styled.div(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        display: flex;
        justify-content: flex-start;
        padding: 0 ${theme.spacing.medium};
        margin-top: ${theme.spacing.xLarge};
        width: 100%;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            width: 13.25rem;
            padding: 0 ${theme.spacing.large};
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            padding: 0;
        }
    `,
)

export const StyledGhostButton = styled.button<{ borderRadius?: string }>(
    ({ theme, borderRadius }) => css`
        color: ${theme.colors.tfwBlack87};
        background-color: ${theme.colors.white};
        padding: ${theme.spacing.xSmall} 1.25rem;
        border: 1px solid ${theme.colors.tfwBlack87};
        border-radius: ${borderRadius || '1rem'};
        width: 100%;
        cursor: pointer;
        transition:
            background-color 0.2s ease,
            border-color 0.2s ease;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            padding: ${theme.spacing.small} 1.25rem;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            padding: ${theme.spacing.small} 3.563rem;
        }

        &:hover {
            background-color: ${theme.colors.tfwYellowHover};
            color: ${theme.colors.tfwBlack87};
            border-color: ${theme.colors.tfwYellowHover};
        }
    `,
)

export const CtaButtonText = styled.div(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-weight: 600;
        font-size: 0.875rem;
        line-height: 1.5rem;
        width: 100%;
        text-align: center;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            font-size: ${theme.typography.font.size.medium};
        }
    `,
)
